<template>
    <PopupRouterView :showLeftIcon="true" label="Repacking Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="repacking"
        :documentId="mainRecordId"
        @hideMethod="onHidden"
        ref="repackingInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-datepicker  id="fieldset-repack-date" class="input-label-detail mb-5" label-cols-lg="12"  label="Repack Date" size="sm" 
							:model="(model.repacking == null) ? '' : model.repacking.repackDate"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" 
							:isEditable="false" :isUpdatable="false" />
						<app-label label-cols-lg="12" size="sm" label="Part No" :model="(model.part == null) ? '' : model.part.partNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(model.part == null) ? '' : model.part.partName" />
						<app-label label-cols-lg="12" size="sm" label="PO No Customer" :model="(model.repacking == null) ? '' : model.repacking.poNoCustomer" />
						<app-input-datepicker  id="fieldset-delivery-date" class="input-label-detail mb-5" label-cols-lg="12"  label="Delivery Date" size="sm" 
							:model="(model.repacking == null) ? '' : model.repacking.deliveryDate"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" 
							:isEditable="false" :isUpdatable="false" />
						<app-label label-cols-lg="12" size="sm" label="Qty Repack" :model="model.qtyRepack" />
					</b-col>
				</b-row>
			</span>

			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12">
						<app-input-datepicker  id="fieldset-repack-date" class="input-label-detail mb-5" label-cols-lg="12"  label="Repack Date" size="sm" 
							:model.sync="model.repacking.repackDate"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" 
							:isEditable="false" :isUpdatable="false" />
						<app-label label-cols-lg="12" size="sm" label="Part No" :model="model.part.partNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="model.part.partName" />
						<app-label label-cols-lg="12" size="sm" label="PO No Customer" :model="model.repacking.poNoCustomer" />
						<app-input-datepicker  id="fieldset-delivery-date" class="input-label-detail mb-5" label-cols-lg="12"  label="Delivery Date" size="sm" 
							:model.sync="model.repacking.deliveryDate"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" 
							:isEditable="false" :isUpdatable="false" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" label="Qty Repack" :model="model.qtyRepack" />
					</b-col>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" label="Qty Fullfiled" :model="model.qtyFullfiled" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-control-card" ref="fieldset-control-card"
							:model.sync="controlCardQrCode" label="Source Control Card"
							@scannedMethod="scanControlCard"
							:isBusy="isScanControlCardLoading"
							:waitInputScan="waitInputScanControlCard" 
							@clearMethod="clearMethodScanControlCard"
							:clearTrigger="clearTriggerValue"
							:isDisabled="isDisableScanControlCard"
							/>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span><strong>Control Card Scanned</strong></span>
						<b-table id="table-list-repacking" 
						:class="'table-action table-index'" 
						head-variant="head-light" 
						:bordered="true" 
						:no-local-sorting="true" 
						:items="repackingControlCards" :fields="fieldsRepackingControlCard" 
						:busy="isDataLoading" small responsive show-empty >
							
							<template v-slot:cell(front-action)="row">
								<b-button variant="outline-danger" @click="revertRepackingCard(row.item.id)"><b-icon icon="trash"></b-icon></b-button>
							</template>
						
							<template v-slot:cell(no)="row">
								{{ (row.index + 1) }}
							</template>
												
							<template v-slot:table-busys>
								<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
									<strong class="ml-2">Loading...</strong>
								</div>
							</template>
							
							<template v-slot:cell(controlCard)="row">
								<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-repacking-control-card-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputRepackingControlCard(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading" :isEditable="false" :isUpdatable="false" :nolabel="true" />
							</template>
							<template v-slot:cell(qtyOriginal)="row">
								<app-input-textbox :id="'input-repacking-control-card-qty-original-' + row.index" label-cols-lg="12" label="Qty Original" size="sm" :model.sync="row.item.qtyOriginal"   @change="saveInputRepackingControlCard(row.item)" :isEditable="false" :isUpdatable="false" :nolabel="false" />
							</template>
							<template v-slot:cell(qty)="row">
								<app-input-textbox :id="'input-repacking-control-card-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   @change="saveInputRepackingControlCard(row.item)" :isEditable="false" :isUpdatable="false" :nolabel="true" />
							</template>
						</b-table>
					</b-col>
				</b-row>
			</span>

			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-input-datepicker  id="fieldset-repack-date" class="input-label-detail mb-5" label-cols-lg="12"  label="Repack Date" size="sm" 
							:model.sync="model.repacking.repackDate"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" 
							:isEditable="false" :isUpdatable="false" />
						<app-label label-cols-lg="12" size="sm" label="Part No" :model="model.part.partNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="model.part.partName" />
						<app-label label-cols-lg="12" size="sm" label="PO No Customer" :model="model.repacking.poNoCustomer" />
						<app-input-datepicker  id="fieldset-delivery-date" class="input-label-detail mb-5" label-cols-lg="12"  label="Delivery Date" size="sm" 
							:model.sync="model.repacking.deliveryDate"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" 
							:isEditable="false" :isUpdatable="false" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" label="Qty Repack" :model="model.qtyRepack" />
					</b-col>
					<b-col cols="6">
						<app-label label-cols-lg="12" size="sm" label="Qty Fullfiled" :model="model.qtyFullfiled" />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span><strong>Control Card Scanned</strong></span>
						<b-table id="table-list-repacking" 
						:class="'table-action table-index'" 
						head-variant="head-light" 
						:bordered="true" 
						:no-local-sorting="true" 
						:items="repackingControlCards" :fields="fieldsSummaryRepackingControlCard" 
						:busy="isDataLoading" small responsive show-empty >
							<template v-slot:cell(no)="row">
								{{ (row.index + 1) }}
							</template>
												
							<template v-slot:table-busys>
								<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
									<strong class="ml-2">Loading...</strong>
								</div>
							</template>
							
							<template v-slot:cell(controlCard)="row">
								<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-repacking-control-card-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputRepackingControlCard(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading" :isEditable="false" :isUpdatable="false" :nolabel="true" />
							</template>
							<template v-slot:cell(qtyOriginal)="row">
								<app-input-textbox :id="'input-repacking-control-card-qty-original-' + row.index" label-cols-lg="12" label="Qty Original" size="sm" :model.sync="row.item.qtyOriginal"   @change="saveInputRepackingControlCard(row.item)" :isEditable="false" :isUpdatable="false" :nolabel="false" />
							</template>
							<template v-slot:cell(qty)="row">
								<app-input-textbox :id="'input-repacking-control-card-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   @change="saveInputRepackingControlCard(row.item)" :isEditable="false" :isUpdatable="false" :nolabel="true" />
							</template>
						</b-table>
					</b-col>
				</b-row>
			</span>
        </div>

        <b-overlay :show="isBusy" no-wrap></b-overlay>

        <template #modal-action-button>
			<b-overlay
				:show="isButtonBusy"
				opacity="0.6"
				spinner-small
				spinner-variant="default"
				class="d-inline">
				<b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right" @click="confirmDelivery()">Next</b-button>
				<b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right mr-1" @click="goBack()">Back</b-button>
				<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right" :disabled="isDisableButtonNext" @click="gotoSummary()">Next</b-button>
				<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right mr-1" @click="gotoPrevious(1)">Back</b-button>
				<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right" @click="addAndPrint()">Add &amp; Print</b-button>
				<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right mr-1" @click="confirmDelivery()">Back</b-button>
			</b-overlay>
			<span></span>
        </template>

    </PopupRouterView>
</template>
<style scoped>
.table thead th {
    min-width: 20px !important;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import Repacking from '@/models/Repacking/Repacking';
import RepackingList from '@/models/Repacking/RepackingList';
import RepackingFilter from '@/filters/Repacking/RepackingFilter';
import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import RepackStatus from '@/models/RepackStatus/RepackStatus';
import RepackStatusFilter from '@/filters/RepackStatus/RepackStatusFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import RepackingDetail from '@/models/Repacking/RepackingDetail';
import RepackingDetailFilter from '@/filters/Repacking/RepackingDetailFilter';
import RepackingControlCard from '@/models/Repacking/RepackingControlCard';
import RepackingControlCardFilter from '@/filters/Repacking/RepackingControlCardFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import RepackingDetailInput from '@/views/Repacking/RepackingDetailInput';
import RepackingDetailScan from '@/views/Repacking/RepackingDetailScan';
import RepackingDetailUpload from '@/views/Repacking/RepackingDetailUpload';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import RepackingControlCardInput from '@/views/Repacking/RepackingControlCardInput';
import RepackingControlCardScan from '@/views/Repacking/RepackingControlCardScan';
import RepackingControlCardUpload from '@/views/Repacking/RepackingControlCardUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PartItem from './components/PartItem';

export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		RepackingDetailInput,
		RepackingDetailScan,
		RepackingDetailUpload,
		RepackingControlCardInput,
		RepackingControlCardScan,
		RepackingControlCardUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
		PartItem,
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsRepackingControlCard: [
				{"front-action": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card", "label" : "Control Card", key: 'controlCard.controlCardNumber', sortable: false}}, 
				{"qtyOriginal": { "class" : "th-qty-original d-stack-none", "label" : "Qty", key: 'qtyOriginal', sortable: false}}, 
				{"qty": { "class" : "th-qty d-stack-none", "label" : "Qty Used", key: 'qty', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsSummaryRepackingControlCard: [
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card", "label" : "Control Card", key: 'controlCard.controlCardNumber', sortable: false}}, 
				{"qtyOriginal": { "class" : "th-qty-original d-stack-none", "label" : "Qty", key: 'qtyOriginal', sortable: false}}, 
				{"qty": { "class" : "th-qty d-stack-none", "label" : "Qty Used", key: 'qty', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelRepackingControlCard : {},
			filterRepacking : null,
			currentRepackingPage : 1,
			repackingPageSize: 10,
			filterRepackingDetail : null,
			currentRepackingDetailPage : 1,
			repackingDetailPageSize: 10,
			sortByRepackingDetail: '',
			sortDescRepackingDetail: '',
			sortingByRepackingDetail: [],
			repackingDetails : [],
			repackingDetailId : '',
			totalRepackingDetailRow : 0,
			filterRepackingControlCard : null,
			currentRepackingControlCardPage : 1,
			repackingControlCardPageSize: 10,
			repackingControlCards : [],
			repackingControlCardId : '',
			totalRepackingControlCardRow : 0,
			isDataCommited : false,
			mainRecordId : '',
			scanPageIndex: 1,
			controlCardQrCode: '',
			isScanControlCardLoading: false,
			waitInputScanControlCard: false,
			clearTriggerValue: false,
			isButtonBusy: false,
			isDisableScanControlCard:false,
			isDisableButtonNext:true,
		}
	},
	methods : {
		async revertRepackingCard(detailId) {
			let _this = this;
			try {
				let msg = "Apakah anda yakin untuk membatalkan penggunaan control card ini?"
				if(!await this.showPopupWithMessage(msg)) return;
				this.isBusy = true;

				const response = await this.$http.post(`Repacking/RevertRepackingCard/${detailId}`);
				if(response && response.data) {
					await _this.getRepackingDetail(_this.model.id);
					await _this.getRepackingControlCards();
					await _this.clearMethodScanControlCard();
					_this.isDisableScanControlCard=false;
					await _this.$nextTick(() => {
						_this.$nextTick(() => {
							_this.focusInput(_this, "fieldset-control-card");
						});
					});

				}
				this.isBusy = false;
			} catch(error) {
				this.$store.dispatch('addErrorMessageGlobal', error);
				this.isBusy = false;
                throw error;
			}
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		async confirmDelivery() {
			let this_ = this;
			this_.isButtonBusy = true;
			this.$http.post('Repacking/ConfirmRepacking/' + this.modelId)
			.then(async function(response) {
				this_.isButtonBusy = false;
				this_.goToNext(2, this_.model);	
			})
			.catch(error => {
				console.log(error);
				this_.isButtonBusy = false;
				this_.toast({message: 'Failed to confirm Delivery Order!', title:'Error', variant : 'danger'});
				this_.isButtonBusy = false;
			});
		},
		async gotoSummary() {
			if(this.repackingControlCards.length == 0) {
				this.toast({message: 'Belum ada SCC yang di scan. Silahkan scan SCC terlebih dahulu!', title:'Error', variant : 'danger'});
			} else {
				this.goToNext(3, this.model);
			}
		},
		async addAndPrint() {
			let id = this.model.id;
			let this_ = this;
			this_.isButtonBusy = true;
			console.log("id", id);
			this.$http.post('Repacking/AddAndPrint/' + id)
			.then(async function(response){
				if(response != null) {
					let result = response.data;
					this_.isButtonBusy = false;
					this_.$router.replace({ name: 'repackingsearchscan' });
					return;
				}
				this_.toast({message: 'Gagal Melakukan finish and print repacking!', title:'Error', variant : 'danger'});
			})
			.catch(error => {
				console.log(error);
				var stringError = 'Control card tidak ditemukan !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError = "";
					console.log('errorList =>',errorList);
					console.log('errorObj =>',errorObj);
					errorList.forEach(element => {
						if (stringError!="") {
							stringError += " \r\n "
						}
						stringError += element[0];
					});
					// stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger',autoHideDelay:3000});
				this_.isButtonBusy = false;
			});
		},
		clearMethodScanControlCard() {
			this.controlCardQrCode = '';
			this.waitInputScanControlCard = false;
		},
		scanControlCard() {
			
			let qrCode = encodeURIComponent(this.controlCardQrCode);
			let id = this.model.id;
			let this_ = this;
			this.$http.post('Repacking/ScanControlCard/' + id + '?qrcode=' + qrCode)
			.then(async function(response){
				if(response != null) {
					let result = response.data;
					this_.getRepackingDetail(this_.model.id).then(() => {
						if(this_.model.qtyFullfiled == this_.model.qtyRepack)
						{
							this_.clearTriggerValue = !this_.clearTriggerValue;
							this_.$nextTick(() => {
								this_.isDisableScanControlCard = true;
								this_.clearMethodScanControlCard();
							});
						}
					});
					this_.getRepackingControlCards();
					return;
				}
				this_.toast({message: 'Control card tidak ditemukan !', title:'Error', variant : 'danger'});
				this_.clearTriggerValue = !this_.clearTriggerValue;
			})
			.catch(error => {
				console.log(error);
				var stringError = 'Control card tidak ditemukan !';
				if (error!=null && error!=undefined && error.response!=null && error.response!=undefined && error.response.data!=null && error.response.data!=undefined && error.response.data.errors!=undefined && error.response.data.errors!=null) {
					let errorList = Object.values(error.response.data.errors);
					const errorObj = errorList.find(() => true);
					stringError =errorObj[0];
				}
				this_.toast({message: stringError, title:'Error', variant : 'danger'});
				this_.clearTriggerValue = !this_.clearTriggerValue;
			});
			this.controlCardQrCode = '';
		},
		gotoPrevious(page) {
			this.scanPageIndex = page;
		},
		goBack() {
			this.$router.replace({ name: 'repackingsearchscan' });
		},
		goToNext(page, item) {
			this.isDisableButtonNext = true;
			let this_ = this;
			this.scanPageIndex = page;
			if(page == 2) {
				// halaman SCAN CONTROL CARD

				this.getRepackingDetail(this.model.id).then(() => {
					console.log('this.model.qtyOutstanding',this.model.qtyOutstanding)
					if(this.model.qtyOutstanding==0 && this.model.qtyFullfiled == this.model.qtyRepack)
					{
						this.isDisableButtonNext = false;
						this.isDisableScanControlCard = true;
					}
					this_.$nextTick(() => {
						this_.focusInput(this_, "fieldset-control-card");
					});
				});
				this.getRepackingControlCards();
			}
			else if (page == 3) {
				// halaman SUMMARY
				this.scanPageIndex = page;
			}
		},
		getRepacking : async function(id) {
			this.isBusy = true;
			Repacking.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getRepackingDetail : async function(id) {
			this.isBusy = true;
			this.isDisableButtonNext = true;
			return RepackingDetail.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				this.isBusy = false;
				console.log('getRepackingDetail', this.model);
				if(this.model.qtyOutstanding==0 && this.model.qtyFullfiled == this.model.qtyRepack)
				{
					this.isDisableButtonNext = false;
					this.isDisableScanControlCard = true;
				}
			}).catch(error => { this.isBusy = false; });
		},
		getRepackingControlCards : async function() {
			console.log('repacking control card')
			let filter = {};
			Object.assign(filter, this.filterRepackingControlCard);
			// filter.repackingId = this.model.repackingId;
			filter.repackingDetailId = this.model.id;
			console.log(this.model.repackingId);
			if (this.sortByRepackingControlCard != null) {
				this.sortingByRepackingControlCard[this.sortByRepackingControlCard] = this.sortDescRepackingControlCard;
			}
			let currentPage = (this.currentRepackingControlCardPage - 1);
			
			// disable paging start
			currentPage = null;
			this.repackingControlCardPageSize = 0;
			// disable paging end
			await RepackingControlCard.getList(this, filter, this.sortingByRepackingControlCard, currentPage , this.repackingControlCardPageSize).then(result => {
				this.currentRepackingControlCardPage = currentPage + 1;
				this.repackingControlCards = result.data;
				this.totalRepackingControlCardRow = result.dataCount;
			}).catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			await ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		handleScroll() {
			this.$refs.repackingInput.scrollTop = 0;
		},
		onHidden() {
			this.getRepackings();
		},
		resetModal(modalType) {
			this.isShowPopupUploadRepackingDetail = false; 
			this.isShowPopupRepackingDetail = false; 
			this.deliveryInstructionQrCode = '';
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
		deleteRowDataRepackingControlCard(item) {

		},
	},
	beforeMount() {
		this.filterRepacking = new RepackingFilter();
		this.filterRepackingDetail = new RepackingDetailFilter();
		this.filterRepackingControlCard = new RepackingControlCardFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getRepackingDetail(id);
		}
		this.$nextTick(() => {
			
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
